import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";
import { openNetworkRegistries } from "../../../../../redux/open-network-registries/action";
import { selectOpenNetworkRegistriesListItems } from "../../../../../redux/open-network-registries/selector";
import RegistiesFilterComponent from "../components/registries-filter.component";
import { toast } from "react-toastify";
import * as R from 'ramda';

const OpenNetworkRegistries = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const openNetworkRegistryItems = useSelector(selectOpenNetworkRegistriesListItems);
  console.log('openNetworkRegistryItems', openNetworkRegistryItems)
  const [
    filterData,
    setFilterData
  ] = useState<any>([])

  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'subscriber_id', headerName: 'subscriber_id', searchField: 'subscriber_id', filter: true, filterType: 'text' },
      { field: 'status', headerName: 'status', filter: true, filterType: 'text' },
      { field: 'ukId', headerName: 'ukId', filter: true, filterType: 'text' },
      { field: 'subscriber_url', headerName: 'subscriber_url', filter: true, filterType: 'text' },
      { field: 'country', headerName: 'country', searchField: 'country', filter: true, filterType: 'text' },
      { field: 'domain', headerName: 'domain', searchField: 'domain', filter: true, filterType: 'text' },
      { field: 'city', headerName: 'city', searchField: 'city', filter: true, filterType: 'text' },
      { field: 'valid_from', headerName: 'valid_from', searchField: 'valid_from', filter: true, filterType: 'text' },
      { field: 'valid_until', headerName: 'valid_until', searchField: 'valid_until', filter: true, filterType: 'text' },
      { field: 'signing_public_key', headerName: 'signing_public_key', searchField: 'signing_public_keyType', filter: true, filterType: 'text' },
      { field: 'encr_public_key', headerName: 'encr_public_key', searchField: 'encr_public_key', filter: true, filterType: 'text' },
      { field: 'br_id', headerName: 'br_id', searchField: 'br_id', filter: true, filterType: 'text' },
      { field: 'created', headerName: 'created', searchField: 'created', filter: true, filterType: 'text' },
      { field: 'updated', headerName: 'updated', searchField: 'updated', filter: true, filterType: 'text' },
    ]);
  }

  const getTypeName = (data: any) => {
    if (Array.isArray(data)) {
      return data.join('\n');
    }
    return data;
  };
  const fetchRegistriesList = async () => {
    await dispatch(openNetworkRegistries.resetAction({ actionType: 'list' }));
    dispatch(openNetworkRegistries.list({
      url: `${process.env.REACT_APP_BPP_URL}/lookup`,
      entity: 'openNetworkRegistries',
      jsonData: {
        "subscriber_id": filterData?.subscriber_id || undefined,
        "type": filterData?.type || 'sellerApp',
        "domain": filterData?.domain || 'ONDC:RET10',
        "country": filterData?.country || 'IND',
        "city": filterData?.city || undefined,
      }
    }))
  }

  useEffect(() => {
    console.log('openNetworkRegistryItems?.result?.items', openNetworkRegistryItems?.result?.items)
  }, [openNetworkRegistryItems]);

  useEffect(() => {
    createColumnDefs()
    fetchRegistriesList()
  }, [pageData, pageSize])


  const handleEdit = (data: any) => {
    navigate(`${data?.GatewayId}/${data?.TenantId}`)
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  const handleInnerFormChange: any = (event: any, field: string) => {
    console.log('event', event, 'field', field)
    setFilterData({ ...filterData, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setFilterData({ ...filterData, [fields[0]]: value });
  }


  const handleReloadData = () => {
    fetchRegistriesList();
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    if (!data?.type || !data?.domain || !data?.country) {
      toast('Type, Domain and Country are mandatory');
      return;
    }

    dispatch(openNetworkRegistries.list({
      url: `${process.env.REACT_APP_BPP_URL}/lookup`,
      entity: 'openNetworkRegistries',
      jsonData: {
        "subscriber_id": data?.subscriber_id || undefined,
        "type": data?.type,
        "domain": data?.domain,
        "country": data?.country,
        "city": data?.city || undefined,
      }
    }))

  }

  const handleSubscribeTrigger = async () => {
    console.log('Trigger subscription to registry')
  }


  return (
    <>

      {openNetworkRegistryItems?.isLoading ? <PageLoader /> :
        <>

          <div className='flex w-full justify-end items-end p-4'>
            <RegistiesFilterComponent
              apply={handleSearch}
              handleInnerFormChange={handleInnerFormChange}
              handleFormChange={handleFormChange}
              selectedGateway={filterData}
            />
          </div>
          <Table columnData={columnDefs}
            rowData={openNetworkRegistryItems?.result?.items || []}
            setPageData={setPageData}
            setPageSize={setPageSize}
            enableFilter={false}
            onSearch={handleSearch}
            paginationData={openNetworkRegistryItems?.result?.pagination}
            onEdit={handleEdit}
            additionButtons={additionButtons}
            handleSubscribeTrigger={handleSubscribeTrigger}
            isEnableSubscribeTrigger={true}
            headingName="ONDC Subscribers Lists"
            checkboxConfig={{
              allowMultiSelect: true,
              defaultSelectedIds: [],
              isDisabled: false,
              keyColumn: 'subscriber_id',
            }}
          />
        </>
      }
    </>
  );
};

export default OpenNetworkRegistries;


